export type UserKeys = {
  apiKeyId?: string;
  clientApiKeyId?: string;
};

export function isApiKeyGenerated(keys?: UserKeys): boolean {
  if (!keys) return false;
  return keys.apiKeyId != null && keys.apiKeyId.length > 0;
}
